module.exports = __webpack_public_path__ + "static/img/jhuplal_khadka.9cefa67e.jpg";